import React from 'react'

function EsignRequested(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <circle cx={13} cy={13} r={13} fill="#F3B300" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.94 11.647a.584.584 0 0 1 .129-.196l4.875-4.875a1.754 1.754 0 1 1 2.48 2.48l-4.875 4.875a.584.584 0 0 1-.196.13l-3.389 1.355a.292.292 0 0 1-.38-.38l1.356-3.389ZM18.815 9.665l-2.48-2.48"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.438 6.063H9.062a3 3 0 0 0-3 3v7.874a3 3 0 0 0 3 3h7.876a3 3 0 0 0 3-3v-3.375"
      />
    </svg>
  )
}
export default EsignRequested
